/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Clear_TimecodesInputs */



/**
* | output |
* | --- |
* | "Clear Timecodes" |
*
* @param {Shortcut_Keys_Name_Clear_TimecodesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_clear_timecodes = /** @type {((inputs?: Shortcut_Keys_Name_Clear_TimecodesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Clear_TimecodesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Effacer les timecodes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zeitcodes löschen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cancella i timecode")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Очистить временные метки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Borrar códigos de tiempo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("清除时间码")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイムコードをクリアする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समय कोड साफ़ करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Limpar códigos de tempo")
	return /** @type {LocalizedString} */ ("Clear Timecodes")
});